const isAppVersionGreater = (appVersion, targetVersion) => {
  const result = appVersion.localeCompare(targetVersion, undefined, {
    numeric: true,
  });
  if (result >= 0) {
    // appVersion is greater than targetVersion
    return true;
  } else {
    // appVersion is less than targetVersion
    return false;
  }
};

export { isAppVersionGreater };
